import { render, staticRenderFns } from "./HidilynDiazWeightliftingTokyo2020.vue?vue&type=template&id=00af8892&scoped=true"
import script from "./HidilynDiazWeightliftingTokyo2020.vue?vue&type=script&lang=js"
export * from "./HidilynDiazWeightliftingTokyo2020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00af8892",
  null
  
)

export default component.exports